import React from 'react';
import { Redirect } from 'react-router-dom';

import SimpleSnackbar from './SimpleSnackbar';

const getMessageFromHttpCode = (code) => {
    switch(code) {
        case 400: return 'Bad request';
        case 404: return 'Specified resource not found';
        case 500: return 'Internal server error';
        default: return 'Unspecified error ' + code;
    }
}

const ajaxErrorMessage = ({ error }) => {
    // If no error was supplied, don't display anything
    if(!error) return null;

    const errorCode = error.response.status;

    // If the AJAX error was caused by a 401 unauthenticated error 
    // Redirect the user back to the login page
    if(errorCode === 401) return <Redirect to="/login" />;

    return (
        <SimpleSnackbar open message={ getMessageFromHttpCode(errorCode) } />
    );
}

export default ajaxErrorMessage;